// Avatar GIF variants
export const INTRODUCTION_TEXT = "The AI-Driven Interview Process Assistant leverages the power of AI to automate and optimize the traditional recruitment process.";

export const GIF_VARIANTS = {
  stable: "/avatar_new_listening.gif",
  speaking: "/avatar_new_speaking.gif",
  listening: "/avatar_new_listening.gif",
};

// Confetti colors for completion screen
export const CONFETTI_COLORS = [
  "bg-blue-500",
  "bg-purple-500",
  "bg-pink-500",
  "bg-yellow-400",
  "bg-green-400",
];

// Waveform configuration
export const WAVEFORM_BAR_COUNT = 16;
export const WAVEFORM_ANIMATION_DOTS = 3;

// Reference: src/contexts/MediaPipeContext.jsx
export const MEDIAPIPE_MODELS = {
  FACE_DETECTOR: "blaze_face_short_range",
  HAND_LANDMARKER: "hand_landmarker",
  OBJECT_DETECTOR: "efficientdet_lite0",
  FACE_LANDMARKER: "face_landmarker",
};

// Model URLs
export const MODEL_URLS = {
  WASM_BASE: "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm",
  FACE_DETECTOR: "https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite",
  HAND_LANDMARKER: "https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task",
  OBJECT_DETECTOR: "https://storage.googleapis.com/mediapipe-models/object_detector/efficientdet_lite0/float16/1/efficientdet_lite0.tflite",
  FACE_LANDMARKER: "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task",
  POSE_LANDMARKER: "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_lite/float16/1/pose_landmarker_lite.task",
};

// Violation count thresholds
export const VIOLATION_THRESHOLDS = {
  MULTIPLE_FACE: 1,
  PROHIBITED_OBJECT: 2,
  BODY_POSTURE: 7,
  GAZE: 5,
  BODY_POSTURE_MODAL: 12,
  GAZE_MODAL: 10,
};

// Cooldown periods (milliseconds)
export const COOLDOWN_PERIOD = {
  MULTIPLE_FACE_COOLDOWN_MS: 10000,
  PROHIBITED_OBJECT_COOLDOWN_MS: 15000,
  BODY_POSTURE_COOLDOWN_MS: 30000,
  GAZE_COOLDOWN_MS: 30000,
  ALERT_WINDOW_MS: 1 * 60 * 1000,
  ALERT_PANEL_AUTO_CLOSE_MS: 7000, 
}

// Timer Settings
export const TIMEOUTS = {
  QUESTION_TIMER_SECONDS: 120,
  ENABLE_NEXT_BUTTON_DELAY_MS: 5000,
  TECHNICAL_TIMEOUT_MS: 180000
}

// Audio Constants
export const AUDIO_CONSTANTS = {
  LOAD_DELAY_MS: 100,
  MAX_RETRIES: 4,
  RETRY_DELAY_MS: 4000,
};


